import { autoMount } from '../../../utils/autoMount';
import { companyPostShow } from '../../../components/organisms/companyPostShow';

autoMount({ companyPostShow });
